import { Site } from 'graphql-api/gql-api-interfaces';

export const sitesWithSubSites = (sites: Site[]) =>
  sites.map((site) => ({
    ...site,
    subSites: site?.subSites?.filter(
      (subSite) => subSite?.isBrandSelectorVisible,
    ),
  }));
